import { render, staticRenderFns } from "./Whats.vue?vue&type=template&id=b037b62c&scoped=true&"
import script from "./Whats.vue?vue&type=script&lang=js&"
export * from "./Whats.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b037b62c",
  null
  
)

export default component.exports